import { ApprovalGroupState } from './types'

export const state: ApprovalGroupState = {
    lsGroupApproval: [],
    countGroupApproval: 0,
    loading: false,
}